// @flow

import {Translate} from "react-redux-i18n";
import React from 'react';
import CurrencyConvertor from "./CurrencyConvertor";

type Props = {
  label: string,
  value: number,
}

class BPBoldKpi extends React.Component<Props> {

  render() {
    return (
      <div>
        <div className="text-bolder"><Translate value={this.props.label} />: </div>
        <CurrencyConvertor value={this.props.value} />
      </div>
    );
  }
}

export default BPBoldKpi;
